import { t } from '@lingui/core/macro';
import type { CarManagerRecord } from '@navio/nsdk';
import { cn, NoddiIcon } from 'noddi-ui-common';

type Props = {
  carManagers?: CarManagerRecord[];
  className?: string;
};

/**
 * The car's driver (car manager) in its user group. Today's assignment, not a
 * snapshot from booking time, so a past booking shows whoever drives the car now.
 */
export const CarManagerNames = ({ carManagers, className }: Props) => {
  if (!carManagers?.length) {
    return null;
  }
  const names = carManagers.map(({ name }) => name).join(', ');

  return (
    <span className={cn('flex min-w-0 items-center gap-1 text-xs text-muted-foreground', className)} title={t`Driver`}>
      <NoddiIcon name='User' size='small' />
      <span className='sr-only'>{t`Driver`}:</span>
      <span className='truncate'>{names}</span>
    </span>
  );
};
